import {
  AwardedFieldsDto,
  BseDto,
  BseStateNameDto,
  BseSupplierViewAwardedFieldsDto,
  DraftFieldsDto,
  PublishedFieldsDto,
  SourcingEventSupplierView,
} from "../../autogen/bff-api";

export const isBse = (event: BseDto | SourcingEventSupplierView): event is BseDto => {
  return (event as BseDto).emailInvites !== undefined;
};

export const isBseSupplierView = (event: BseDto | SourcingEventSupplierView): event is BseDto => {
  return (event as SourcingEventSupplierView).contactPerson !== undefined;
};

export const isBseDraft = (event: BseDto): event is BseDto & { draftFields: DraftFieldsDto } => {
  return event.draftFields !== null;
};

export const isPublishedBse = (event: BseDto): event is BseDto & { publishedFields: PublishedFieldsDto } => {
  return event.publishedFields !== null;
};

export const isCompletedBse = (event: BseDto): boolean => event.stateName === BseStateNameDto.Completed;

export const isAwardedBse = (event: BseDto): event is BseDto & { awardedFields: AwardedFieldsDto } => {
  return event.awardedFields !== null;
};

export const isCancelledBse = (event: BseDto): boolean => event.stateName === BseStateNameDto.Cancelled;

export const isClosedBse = (event: BseDto): boolean => event.stateName === BseStateNameDto.Closed;

export const isPublishedOrAwardedBse = (
  event: BseDto
): event is (BseDto & { publishedFields: PublishedFieldsDto }) | (BseDto & { awardedFields: AwardedFieldsDto }) => {
  return event.publishedFields !== null || event.awardedFields !== null;
};

export const isAwardedBseSupplierView = (
  event: SourcingEventSupplierView
): event is SourcingEventSupplierView & {
  awardedFieldsDto: BseSupplierViewAwardedFieldsDto;
} => {
  return event.awardedFieldsDto !== null;
};
